export default __webpack_public_path__ + "static/media/pic6.13ab1904.jpg";